import { Action, ReducersMapObject } from 'redux';
import { combineReducers as immutableCombineReducers } from 'redux-immutable';
import { CombinedReducer } from './checkStore';
import { StoreEnvOptions } from './getStoreEnvOptions';

/**
 * Create reducer creator
 *
 * @name createReducerCreator
 * @function
 * @param {Function} [combineReducers = immutableCombineReducers] - create combination of reducers
 * @param {Object} predefinedReducers - original (predefined) reducers
 *
 * @returns {createReducer}
 */
export const createReducerCreator = <S, A extends Action>(
  combineReducers: StoreEnvOptions['combineReducers'] = immutableCombineReducers,
  predefinedReducers: ReducersMapObject<S, A> = {} as ReducersMapObject<S, A>,
) =>
  /**
   * Create root reducer
   *
   * @name createReducer
   * @function
   * @param {Object} injectedReducers - injected reducers
   * @returns {Function} - combination of reducers
   */
  <SR, AR extends Action>(
    injectedReducers: ReducersMapObject<SR, AR> = {} as ReducersMapObject<SR, AR>,
  ): CombinedReducer<S, A, SR, AR> => {
    return combineReducers({
      ...predefinedReducers,
      ...injectedReducers,
    });
  };
